import { render, staticRenderFns } from "./nationwideData.vue?vue&type=template&id=a4b8a284&scoped=true&"
import script from "./nationwideData.vue?vue&type=script&lang=js&"
export * from "./nationwideData.vue?vue&type=script&lang=js&"
import style0 from "./nationwideData.vue?vue&type=style&index=0&id=a4b8a284&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b8a284",
  null
  
)

export default component.exports